<template>
  <div ref="MainRef" class="common-layout">
    <el-container>
      <el-header height="10%">
        <div class="main-herder">
          <div class="information">
            <div
              style="
                display: flex;
                flex: 3;
                justify-content: center;
                height: 60%;
              "
            >
              <!-- <el-avatar :size="80" :src="circleUrl" /> -->
              <img :src="circleUrl">
            </div>
            <div
              style="
                height: 100%;
                width: 100%;
                display: flex;
                flex: 6;
                flex-direction: column;
                justify-content: center;
              "
            >
              <div style="margin: 5px 0px; font-size:calc(100vw * 22 / 1920);font-weight:bold;">会展数字化运营管理仿真实验平台</div>
            </div>
          </div>
          <div
            style="
              flex: 1;
              display: flex;
              justify-content: space-around;
              margin-top: 10px;
            "
          >
            <div style="display: flex; flex: 3"></div>
            <div class="fund" v-if="headShow">
              <!-- <h5 style="position: absolute; top: 5px;right: 5px;color: #0166FF;">当前资金</h5> -->
              <div style="display: flex; flex-direction: column; align-items: center;flex: 1;">
                <div>
                  <svg t="1711096695626" class="icon" viewBox="0 0 1271 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10105" width="calc(100vw * 30 / 1920)" height="calc(100vw * 30 / 1920)"><path d="M792.628966 1.588966C971.211034 101.270069 1092.201931 292.31669 1092.201931 512c0 219.68331-120.973241 410.676966-299.572965 510.411034C1059.628138 1005.991724 1271.172414 784.066207 1271.172414 512 1271.172414 239.933793 1059.539862 18.114207 792.628966 1.588966zM1020.574897 512c0-282.747586-228.457931-512-510.287449-512S0 229.252414 0 512c0 282.782897 228.457931 512 510.287448 512s510.287448-229.217103 510.287449-512z m-299.908414 89.758897c24.134621-0.300138 42.496 16.384 42.496 46.344827s-17.019586 47.386483-42.496 46.309517l-140.72938-0.741517v78.000552c-0.653241 41.666207-24.717241 62.481655-68.184275 62.481655-42.955034 0-67.725241-20.303448-69.632-62.481655v-76.517517h-141.506207c-26.394483-1.906759-43.237517-18.361379-43.237518-49.999449 0-31.638069 16.843034-41.454345 43.255173-43.396413h141.488552v-46.344828l-141.506207-0.741517c-26.394483-1.995034-43.237517-17.160828-43.237518-45.620966 0-28.477793 16.843034-41.419034 43.255173-43.361103h105.560276l-98.251035-173.585655c-19.297103-32.997517-21.98069-71.062069 6.497104-90.712276 28.495448-19.650207 64.635586-8.280276 83.685517 23.763862l111.404138 204.482207 122.438621-205.947587c16.984276-30.331586 45.956414-51.041103 83.01462-31.744 31.814621 16.560552 29.184 54.342621 11.599449 88.417104l-113.646345 185.326345h107.767172c25.388138 1.995034 42.496 11.122759 42.496 43.414069 0 32.273655-17.831724 45.038345-43.255172 47.051034l-140.005518 0.741517v44.844138h140.72938v0.017656z" fill="#FDBB3F" p-id="10106"></path></svg>
                  <!-- <svg t="1710814418482" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6728" width="calc(100vw * 30 / 1920)" height="calc(100vw * 30 / 1920)"><path d="M708 460a36 36 0 0 0 36-36 36 36 0 0 0-36-36H316a36 36 0 0 0-36 36 36 36 0 0 0 36 36h160v72H316a36 36 0 0 0-36 36 36 36 0 0 0 36 36h160v142.91A33.08 33.08 0 0 0 509.09 780h5.82A33.08 33.08 0 0 0 548 746.91V604h160a36 36 0 0 0 36-36 36 36 0 0 0-36-36H548v-72z" :fill="Global.globalColor" p-id="6729"></path><path d="M511.8 388a35.33 35.33 0 0 0 25.28-10.4l72.56-72.8a35.83 35.83 0 0 0 0-50.4 35.52 35.52 0 0 0-50.23 0l-47.13 47.29-47-47.18a35.93 35.93 0 0 0-50.78 0 36.22 36.22 0 0 0 0 51l71.76 72A35.76 35.76 0 0 0 511.8 388z" :fill="Global.globalColor" p-id="6730"></path><path d="M100 400.71h144a36 36 0 0 0 36-36 36 36 0 0 0-36-36h-60.33C248 213.74 370.9 136 512 136c195.76 0 356.57 149.6 374.36 340.71H886a36 36 0 0 0 36 36 36 36 0 0 0 36-36h0.6C940.63 245.79 747.55 64 512 64c-157.59 0-296.14 81.38-376 204.39v-47.68a36 36 0 0 0-36-36 36 36 0 0 0-36 36v144a36 36 0 0 0 36 36zM924 624.71H780a36 36 0 0 0-36 36 36 36 0 0 0 36 36h59.51C775 810.9 652.51 888 512 888c-195.27 0-355.77-148.86-374.22-339.29h-0.29a36 36 0 0 0-36-36 36 36 0 0 0-36 36C84.17 779 276.94 960 512 960c157.58 0 296.15-81.37 376-204.38v49.09a36 36 0 0 0 36 36 36 36 0 0 0 36-36v-144a36 36 0 0 0-36-36z" :fill="Global.globalColor" p-id="6731"></path></svg> -->
                </div>
                <!-- <div style="font-size: 12px;font-weight: 600;">当前资金</div> -->
              </div>
              <div style=" flex: 3;">
                <CountTo  prefix="￥"
                   :startVal="startVal"
                   :endVal="Money"
                   :decimals="2"
                   :duration="duration" style="color: #FF6B3C;  font-size:calc(100vw * 20 / 1920); "></CountTo>
              </div>
            </div>
            <div class="fund2" v-if="headShow">
              <!-- <h5 style="position: absolute; top: 5px;right: 5px;color: #0166FF">当前回合</h5>   -->
              <div style="display: flex; flex-direction: column; align-items: center;flex: 3;">
                <div>
                  <svg t="1711096394916" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5268" width="calc(100vw * 28 / 1920)" height="calc(100vw * 24 / 1920)"><path d="M505.303923 748.961156L300.623853 896.074956c-12.792504 6.396252 12.792504 6.396252 12.792505 6.396252h377.378879c19.188757 0 0-25.585009 0-25.585009-57.56627-83.151279-108.736287-115.13254-140.717548-134.321296-31.981261-19.188757-44.773765 6.396252-44.773766 6.396253z m0 0M665.210228 179.69471h-319.812609s-25.585009 83.151279 95.943783 166.302557c0 0 51.170018 31.981261 63.962521 115.13254v6.396252-6.396252c6.396252-83.151279 63.962522-115.13254 63.962522-115.13254 121.528792-83.151279 95.943783-166.302557 95.943783-166.302557z m0 0" fill="#45D0A6" p-id="5269"></path><path d="M639.62522 397.167285C773.946516 294.82725 793.135272 154.109701 793.135272 90.147179h31.981261c25.585009 0 44.773765-19.188757 44.773766-44.773765 0-25.585009-19.188757-44.773765-44.773766-44.773765H198.283818c-25.585009 0-44.773765 19.188757-44.773765 44.773765 0 25.585009 19.188757 44.773765 44.773765 44.773765h31.981261c0 63.962522 19.188757 204.68007 153.510053 307.020106 44.773765 31.981261 70.358774 70.358774 70.358774 115.132539 0 70.358774-63.962522 121.528792-70.358774 121.528792C370.982627 640.224868 230.265079 742.564903 230.265079 934.452469h-31.981261c-25.585009 0-44.773765 19.188757-44.773765 44.773766 0 25.585009 19.188757 44.773765 44.773765 44.773765h626.832715c25.585009 0 44.773765-19.188757 44.773766-44.773765 0-25.585009-19.188757-44.773765-44.773766-44.773766h-31.981261c0-191.887566-147.113801-294.227601-153.510052-300.623853-6.396252-6.396252-70.358774-57.56627-70.358775-121.528792 0-44.773765 19.188757-83.151279 70.358775-115.132539zM537.285184 512.299824c0 83.151279 76.755026 140.717548 83.151279 147.113801 0 0 140.717548 95.943783 140.717548 275.038844h-511.700175c0-179.095061 140.717548-275.038844 140.717548-275.038844 6.396252 0 83.151279-63.962522 83.151279-147.113801 0-51.170018-25.585009-95.943783-83.151279-134.321296-115.13254-95.943783-134.321296-230.265079-134.321296-287.831349h505.303923c0 57.56627-19.188757 185.491314-140.717548 281.435097-51.170018 44.773765-83.151279 89.547531-83.151279 140.717548z m0 0" fill="#1F88E4" p-id="5270"></path></svg>
                  <!-- <svg t="1710815524904" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="17939" width="calc(100vw * 28 / 1920)" height="calc(100vw * 28 / 1920)"><path d="M512 0a512 512 0 1 1 0 1024A512 512 0 0 1 512 0z m0 73.142857a438.857143 438.857143 0 1 0 0 877.714286A438.857143 438.857143 0 0 0 512 73.142857z m162.230857 359.350857l54.784 55.515429L512 707.072l-54.784-55.588571 0.146286-0.073143L296.96 488.009143l56.978286-55.588572 158.500571 163.474286 161.792-163.401143z" :fill="Global.globalColor" p-id="17940"></path></svg> -->
                </div>
                <!-- <div style="font-size: 12px;font-weight: 600;margin-top: 1px;">回合</div> -->
              </div>
              <div style=" flex: 5;">
                <CountTo  prefix="第"
                   :startVal="startVal"
                   :endVal="Round"
                   :duration="duration" style="color: #FF6B3C;  font-size:calc(100vw * 20 / 1920); "></CountTo>
                   <span style="color: #FF6B3C;  font-size:calc(100vw * 20 / 1920); ">回合</span>
              </div>
            </div>
            <el-tooltip
                class="box-item"
                effect="dark"
                content="当前排名：（排名/小组数）"
                placement="bottom"
              >
            <div class="fund3" v-if="headShow" style="justify-content:center">
              <div style="display: flex; flex-direction: column; align-items: center;flex: 2;">
                <div>
                  <svg t="1713428890566" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9781" width="calc(100vw * 32 / 1920)" height="calc(100vw * 28 / 1920)"><path d="M521.813333 226.56l-58.453333 42.666667 22.186667-68.693334-58.453334-42.666666h72.533334l22.186666-68.693334 22.186667 68.693334h72.533333l-58.453333 42.666666 22.186667 68.693334zM254.72 517.546667L196.266667 559.36l22.613333-68.266667-58.88-42.666666h72.533333L258.986667 379.733333l18.346666 68.693334h72.533334l-58.88 42.666666 22.613333 68.266667zM787.626667 414.72l-58.88 42.666667 22.613333-69.12-58.88-42.666667h72.533333l9.813334-69.12 34.986666 69.12h72.533334l-58.453334 42.666667 22.186667 69.12zM581.973333 320.853333h-119.466666c-28.16 0-51.2 23.04-51.2 51.2v512c0 28.16 23.04 51.2 51.2 51.2h119.466666c28.16 0 51.2-23.04 51.2-51.2v-512c0-28.586667-23.04-51.2-51.2-51.2z m-17.066666 546.133334h-85.333334v-477.866667h85.333334v477.866667zM314.88 627.626667h-119.466667c-28.16 0-51.2 23.04-51.2 51.2v204.8c0 28.16 23.04 51.2 51.2 51.2h119.466667c28.16 0 51.2-23.04 51.2-51.2v-204.8c0-28.16-23.04-51.2-51.2-51.2z m-17.066667 239.36h-85.333333v-170.666667h85.333333v170.666667zM848.64 525.653333h-119.466667c-28.16 0-51.2 23.04-51.2 51.2v307.2c0 28.16 23.04 51.2 51.2 51.2h119.466667c28.16 0 51.2-23.04 51.2-51.2v-307.2c0-28.586667-23.04-51.2-51.2-51.2z m-17.066667 341.333334h-85.333333v-273.066667h85.333333v273.066667z" fill="#1296db" p-id="9782"></path></svg>
                </div>
              </div>
              <div style="display: flex;flex: 6;">
                <!-- <CountTo  prefix="当前排名："
                   :startVal="startVal"
                   :endVal="scoreRank"
                   :duration="duration" style="color: #FF6B3C;  font-size:calc(100vw * 20 / 1920); "></CountTo> -->
                   <span style="color: #FF6B3C;  font-size:calc(100vw * 20 / 1920); ">当前排名：{{scoreRank}}/{{ groupCount }}</span>
              </div>
            </div>
            </el-tooltip>
            <div v-if="headShow" style="background-color: #fff;border-radius: 5px;width: 4%;margin-right: 10px;height: 60%;opacity: 0.85;cursor: pointer;">
              <el-dropdown class="user-name" style=" height: 100%;width: 100%;"
                     trigger="click"
                     @command="handleCommand">
              <div style="height: 100%;width: 100%;display: flex; justify-content: center; align-items: center;">
                <!-- <i class="iconfont icon-IMliaotian iconsize"
                  style="font-size:calc(100vw * 30 / 1920);color: #0166FF;"
                ></i> -->
                <svg t="1714284896478" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10238" width="calc(100vw * 35 / 1920)" height="calc(100vw * 35 / 1920)"><path d="M217.9 356.5c-14.1 0-25.5 11.4-25.5 25.5s11.4 25.5 25.5 25.5 25.5-11.4 25.5-25.5-11.4-25.5-25.5-25.5zM217.4 433.7c-11.2 0-20.4 9.2-20.4 20.4v174.4c0 11.2 9.2 20.4 20.4 20.4s20.4-9.2 20.4-20.4V454.1c0-11.2-9.2-20.4-20.4-20.4z" fill="#6B400D" p-id="10239"></path><path d="M878.7 379.5v-86c0-96.3-57.5-153.7-153.7-153.7H218c-96.3 0-153.7 57.5-153.7 153.7v320.7C64.3 710.5 121.8 768 218 768h45.8v120.4L449.9 768h11.2c17.2 11.3 39 17.5 64.6 17.5h161.6l130.7 85v-85.1h33.5c66.6 0 107.9-41.3 107.9-107.9V484.8c-0.1-56.9-30.3-95.3-80.7-105.3zM417.8 484.8v192.8c0 16.2 2.5 31 7.2 44l-106.1 70.1v-74.9h-101c-67.7-0.3-102.2-34.8-102.5-102.5V293.5c0.3-67.7 34.8-102.2 102.5-102.5H725c67.7 0.3 102.2 34.8 102.5 102.5v83.3H525.7c-66.5 0.1-107.9 41.4-107.9 108z m490.4 192.7c-0.2 38.6-18.2 56.6-56.7 56.7h-87.2v40.3l-61-40.3H525.7c-38.5-0.2-56.6-18.2-56.7-56.7V484.8c0.2-38.6 18.2-56.6 56.7-56.7h325.7c38.5 0.2 56.6 18.2 56.7 56.7v192.7z" fill="#6B400D" p-id="10240"></path><path d="M851.4 428.1H525.7c-38.5 0.2-56.6 18.2-56.7 56.7v192.8c0.2 38.5 18.2 56.6 56.7 56.7h177.5l61 40.3v-40.3h87.2c38.5-0.2 56.6-18.2 56.7-56.7V484.8c-0.1-38.6-18.1-56.6-56.7-56.7zM567 627.4c-21.1 0-38.3-17.2-38.3-38.3 0-21.1 17.2-38.3 38.3-38.3 21.1 0 38.3 17.2 38.3 38.3 0 21.1-17.2 38.3-38.3 38.3z m122.2 0c-21.1 0-38.3-17.2-38.3-38.3 0-21.1 17.2-38.3 38.3-38.3 21.1 0 38.3 17.2 38.3 38.3 0 21.1-17.2 38.3-38.3 38.3z m122.3 0c-21.1 0-38.3-17.2-38.3-38.3 0-21.1 17.2-38.3 38.3-38.3 21.1 0 38.3 17.2 38.3 38.3 0 21.1-17.2 38.3-38.3 38.3z" fill="#FFD524" p-id="10241"></path><path d="M567 550.8c-21.1 0-38.3 17.2-38.3 38.3 0 21.1 17.2 38.3 38.3 38.3 21.1 0 38.3-17.2 38.3-38.3 0-21.1-17.2-38.3-38.3-38.3zM689.2 550.8c-21.1 0-38.3 17.2-38.3 38.3 0 21.1 17.2 38.3 38.3 38.3 21.1 0 38.3-17.2 38.3-38.3 0-21.1-17.2-38.3-38.3-38.3zM811.5 550.8c-21.1 0-38.3 17.2-38.3 38.3 0 21.1 17.2 38.3 38.3 38.3 21.1 0 38.3-17.2 38.3-38.3 0-21.1-17.2-38.3-38.3-38.3z" fill="#6B400D" p-id="10242"></path></svg>
              </div>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item divided @click="sendclick(1)">
                        沙盘精灵
                  </el-dropdown-item>
                  <el-dropdown-item divided @click="sendclick(0)">
                        聊天窗口
                  </el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
            <div v-if="headShow" style="background-color: #fff;border-radius: 5px;width: 4%;margin-right: 10px;height: 60%;opacity: 0.85;cursor: pointer;" @click="MarketClick">
              <el-tooltip
                class="box-item"
                effect="dark"
                content="市场调研分析"
                placement="bottom"
              >
              <div style="height: 100%;width: 100%;display: flex; justify-content: center; align-items: center;">
                <i class="icon iconfont icon-shujukanban"
                       style="font-size:calc(100vw * 30 / 1920);color:#0166FF"></i>           
              </div>
            </el-tooltip>
            </div>
            <div v-if="headShow" style="background-color: #fff;border-radius: 5px;width: 4%;margin-right: 10px;height: 60%;opacity: 0.85;cursor: pointer;" @click="AchievementsClick">
              <el-tooltip
                class="box-item"
                effect="dark"
                content="成就"
                placement="bottom"
              >
              <div style="height: 100%;width: 100%;display: flex; justify-content: center; align-items: center;">
                <svg t="1714284824854" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7373" width="calc(100vw * 30 / 1920)" height="calc(100vw * 30 / 1920)"><path d="M0 0h1024v1024H0V0z" fill="#202425" opacity=".01" p-id="7374"></path><path d="M170.666667 34.133333h187.733333v166.2976a409.258667 409.258667 0 0 0-102.229333 59.938134l-119.9104-69.973334A68.266667 68.266667 0 0 1 102.4 131.4816V102.4a68.266667 68.266667 0 0 1 68.266667-68.266667z m597.162666 226.235734l119.9104-69.973334A68.266667 68.266667 0 0 0 921.6 131.4816V102.4a68.266667 68.266667 0 0 0-68.266667-68.266667h-187.733333v166.2976a409.258667 409.258667 0 0 1 102.229333 59.938134zM631.466667 188.347733V34.133333h-238.933334v154.2144A409.565867 409.565867 0 0 1 512 170.666667c41.5744 0 81.681067 6.178133 119.466667 17.681066z" fill="#FFAA44" p-id="7375"></path><path d="M921.6 580.266667c0 226.2016-183.3984 409.6-409.6 409.6S102.4 806.468267 102.4 580.266667 285.7984 170.666667 512 170.666667s409.6 183.3984 409.6 409.6z" fill="#FF7744" p-id="7376"></path><path d="M512 426.666667a153.6 153.6 0 1 0 0 307.2 153.6 153.6 0 0 0 0-307.2zM256 580.266667a256 256 0 1 1 512 0 256 256 0 0 1-512 0z" fill="#FFFFFF" p-id="7377"></path></svg>           
              </div>
              </el-tooltip>
            </div>
            <div v-if="headShow" style="background-color: #fff;border-radius: 5px;width: 4%;margin-right: 10px;height: 60%;opacity: 0.85;cursor: pointer;">
              <el-dropdown class="user-name" style=" height: 100%;width: 100%;"
                     trigger="click"
                     @command="handleCommand">
              <div style="height: 100%;width: 100%;display: flex; justify-content: center; align-items: center;">
                <el-badge :value="taskBarList.length" 
                    class="item">
                    <i class="icon iconfont icon-mc-wcqk" style="  font-size:calc(100vw * 30 / 1920); color: #0166FF;"></i>
                </el-badge>
              </div>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item divided
                                v-for="(o, i) in taskBarList"
                                :key="i"
                                @click="Jump(o)">
                    <i class="icon iconfont icon-shouzhi"
                      style="font-size:calc(100vw * 20 / 1920);margin-right:5px"></i>
                    [{{o.menu}}]>{{o.task}}未完成
                  </el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
            <div v-if="experimentShow" style="background-color: #fff;border-radius: 5px;width: 4%;margin-right: 10px;height: 60%;opacity: 0.85;cursor: pointer;" @click="ScoringRulesClick">
              <el-tooltip
                class="box-item"
                effect="dark"
                content="评分规则"
                placement="bottom"
              >
              <div style="height: 100%;width: 100%;display: flex; justify-content: center; align-items: center;">
              <svg t="1717119405519" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1624" width="calc(100vw * 32 / 1920)" height="calc(100vw * 32 / 1920)"><path d="M719 846.7l10.2 110 78.2-78 120-332-88.4-32z m129.89-359.31l21.785-60.18 88.389 31.998-21.786 60.18zM288.9 224.3c17.7 0 32-14.3 32-31.9v-96c0-17.6-14.3-31.9-32-31.9h-0.1c-17.6 0-31.9 14.3-31.9 31.9v95.9c0 17.7 14.4 32 32 32z m95.9-32h64.1c17.6 0 31.9-14.3 31.9-31.9 0-17.6-14.3-31.9-31.9-31.9h-64.1c-17.6 0-32 14.3-32 31.9 0.1 17.6 14.4 31.9 32 31.9z m160 32c17.7 0 32-14.3 32-31.9v-96c0-17.6-14.3-31.9-32-31.9h-0.1c-17.6 0-31.9 14.3-31.9 31.9v95.9c0.1 17.7 14.4 32 32 32z m-0.1 671.3H160.9c-17.7 0-32-14.3-32-32V224.3c0-17.7 14.3-32 32-32h32c17.6 0 32-14.3 32-31.9 0-17.6-14.3-31.9-32-31.9h-32c-53 0-95.9 42.9-95.9 95.9v639.3c0 53 43 95.9 95.9 95.9h383.7c17.6 0 32-14.3 32-32s-14.3-32-31.9-32z m192-383.6c17.6 0 31.9-14.3 31.9-31.9V224.3c0-53-43-95.9-95.9-95.9h-32c-17.6 0-32 14.3-32 31.9 0 17.6 14.3 31.9 32 31.9h32c17.7 0 32 14.3 32 32V480c0 17.7 14.3 32 32 32z" fill="#1296DB" p-id="1625"></path><path d="M404.7 489c-4.1-10.7-7.5-19.2-10.1-25.5-2.6-6.4-5.9-12.3-9.8-17.9-3.9-5.5-8.9-10.1-15.2-13.6-6.3-3.5-14.1-5.3-23.5-5.3-9.2 0-17 1.8-23.3 5.3-6.3 3.5-11.4 8.1-15.2 13.8-3.9 5.7-7.5 12.9-10.9 21.5-3.4 8.6-6.3 16-8.7 22.2l-85.1 214.3c-3.5 8.6-6 15.2-7.5 20-1.5 4.8-2.3 9.5-2.3 14 0 7.8 3.3 14.8 9.8 20.9 6.5 6.2 14 9.2 22.5 9.2 10 0 17.2-2.9 21.6-8.7 4.4-5.8 9.7-16.9 15.9-33.4l15.9-42.3H414l15.9 41.4c2.1 5.1 4.7 11 7.6 17.7 3 6.7 5.7 11.6 8.3 14.9 2.6 3.2 5.8 5.8 9.5 7.7 3.8 1.9 8.3 2.8 13.6 2.8 9.1 0 16.8-3.2 23.3-9.6 6.4-6.4 9.6-13.4 9.6-21 0-7.3-3.4-19.1-10.2-35.3L404.7 489zM296.4 633.2L345.7 497l50.2 136.2h-99.5zM607 408h-32v-32c0-17.7-14.3-32-32-32s-32 14.3-32 32v32h-32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32v-32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32z" fill="#0166FF" p-id="1626"></path></svg>
            </div>
            </el-tooltip>
            </div>
            <div class="fund1">
              <el-dropdown class="user-name" style=" height: 100%;width: 100%;"
                     trigger="click"
                     @command="handleCommand">
              <div style="height: 100%;width: 100%;">
                <img src="../images/Personal.png">
              </div>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item divided
                                    command="myCollect" v-if="headShow">我的收藏</el-dropdown-item>
                                    <el-dropdown-item divided
                                    command="loginout">退出系统</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
          </div>
        </div>
      </el-header>
      <el-main >
        <div class="main-div">
          <div v-if="MainShow" class="main-left">  
            <div class="mune-calss" v-for="item in muunlist" :key="item.index"  @click="MeunClick(item)" :style="dynamicStyles(item)">
              <div class="left-icon">
                <i :class="item.icon"
                  style="font-size: 3vw;color: #fff;"
                ></i>
              </div>
              <div>
                <div class="left-text" style="font-size:calc(100vw * 18 / 1920)">{{item.title}}</div>
              </div>
            </div>
          </div>
          <div class="main-center">
            <router-view style="width: 95%;" />
          </div>
          <div class="main-right">
              <div />
              <!-- <div  v-show="isSend">
                <SendBox ref="child"></SendBox>
              </div> -->
              <div id="send"
                v-show="isSend" :style="{border : '1px solid '+ Global.globalColor}">
              <svg t="1663665057037"
                  class="icon close"
                  @click="sendclickclose"
                  style="cursor: pointer; padding: 6px;  position: fixed;right: 10px;"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="7039"
                  width="32"
                  height="32">
                <path d="M1022.293364 470.409918a511.990827 511.990827 0 1 0-551.883445 551.883446 513.484133 513.484133 0 0 0 551.883445-551.883446zM625.073814 549.768497l100.264871 100.05154A53.332378 53.332378 0 1 1 649.820038 725.338684l-100.051541-100.26487a53.759037 53.759037 0 0 0-75.518647 0L374.198309 725.338684A53.332378 53.332378 0 1 1 298.679662 649.820037l100.264871-100.05154a53.759037 53.759037 0 0 0 0-75.518647L298.679662 374.198309A53.332378 53.332378 0 0 1 374.198309 298.679662l100.051541 100.26487a53.759037 53.759037 0 0 0 75.518647 0l100.051541-100.26487A53.332378 53.332378 0 1 1 725.338685 374.198309l-100.264871 100.051541a53.759037 53.759037 0 0 0 0 75.518647z"
                      fill="#D33737"
                      p-id="7040"></path>
              </svg>
                <SendBox ref="child" style="width: 100%;"></SendBox>
              </div>
              <!-- <div style="position: fixed; bottom: 50px; right: 0px; z-index: 99">
                <div class="demo">
                  <div>
                    <div class="row">
                      <div class="col-md-12">
                        <el-badge :value="unreadmsg"
                                  :hidden="unreadmsg <= 0"
                                  class="item"
                                  type="danger">
                          <div class="navbar">
                            <i class="iconfont icon-caidan iconsize"
                              style="color: #fff;"
                              @click="isbtn = !isbtn"></i>
                            <ul class="menu"
                                v-if="isbtn">
                              <li>
                                <a href="javascript:void(0)"
                                  class="iconfont icon-jiqiren iconsize"
                                  :style="{
                                    color: clasclick == 1 ? 'rgb(9, 240, 240)' : '',
                                  }"
                                  @click="sendclick(1)"></a>
                              </li>
                              <li>
                                <span class="event-count"
                                      v-show="unreadmsg > 0">{{
                                  unreadmsg
                                }}</span>
                                <a href="javascript:void(0)"
                                  class="iconfont icon-IMliaotian iconsize"
                                  :style="{
                                    color: clasclick == 0 ? 'rgb(9, 240, 240)' : '',
                                  }"
                                  @click="sendclick(0)"></a>
                              </li>
                              <li>
                                <a href="javascript:void(0)"
                                  class="icon iconfont icon-shujukanban"
                                  @click="BtnMarketReport"></a>
                              </li>
                            </ul>
                          </div>
                        </el-badge>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
              <!-- <div class="right-div">
                <div class="right-teles" @click="rightMuneShow = !rightMuneShow">
                  <svg v-if="rightMuneShow" t="1709707170053" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1788" width="200" height="225">
                    <path d="M305.587883 813.744345c-14.09502 12.824073-15.126512 34.658358-2.303462 48.752354 12.843516 14.09502 34.678824 15.126512 48.752354 2.302439l364.835266-332.676845c14.114462-12.844539 15.127536-34.659381 2.302439-48.753377-0.733711-0.815575-1.486864-1.588171-2.302439-2.302439l-0.078795-0.080841-0.13917-0.13917L352.037798 148.369166c-14.074553-12.824073-35.909861-11.791557-48.752354 2.302439-12.824073 14.09502-11.792581 35.930327 2.303462 48.753377l336.845795 307.168891L305.588907 813.743322 305.587883 813.744345 305.587883 813.744345z" fill="#272536" p-id="1789" />
                  </svg>
                  <svg v-if="!rightMuneShow" t="1709707978255" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2094" width="200" height="225">
                    <path d="M716.879204 813.744345c14.09502 12.824073 15.126512 34.658358 2.303462 48.752354-12.843516 14.09502-34.678824 15.126512-48.752354 2.302439l-364.835266-332.676845c-14.114462-12.844539-15.127536-34.659381-2.302439-48.753377 0.733711-0.815575 1.486864-1.588171 2.302439-2.302439l0.078795-0.080841 0.13917-0.13917 364.616278-332.4773c14.074553-12.824073 35.909861-11.791557 48.752354 2.302439 12.824073 14.09502 11.792581 35.930327-2.303462 48.753377L380.032386 506.593873l336.845795 307.149449L716.879204 813.744345 716.879204 813.744345z" fill="#272536" p-id="2095" />
                  </svg>
                </div>
                <transition name="el-zoom-in-right">
                  <div v-if="rightMuneShow" class="right-mune">
                    <div class="mune-calss">
                      <div class="left-icon">
                        <svg-icon icon-class="bankruptcy" class-name="card-panel-icon" />
                      </div>
                      <div>
                        <div class="left-text">申请破产</div>
                      </div>
                    </div>
                    <div class="mune-calss" @click="ExitSystem">
                      <div class="left-icon">
                        <svg t="1709701947543" class="icon" viewBox="0 0 1025 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3606" width="48" height="48">
                          <path d="M521.378227 948.645124h-402.185168a42.19288 42.19288 0 0 1-29.981076-11.919305 41.607884 41.607884 0 0 1-13.162424-29.249831V116.560574a41.461635 41.461635 0 0 1 13.162424-29.24983 43.216624 43.216624 0 0 1 29.981076-11.992431h404.378905a37.586032 37.586032 0 1 0 0-75.098939H119.193059A118.09619 118.09619 0 0 0 0 116.779948v790.622916a118.09619 118.09619 0 0 0 119.193059 116.560574h402.185168a37.586032 37.586032 0 1 0 0-75.09894z m0 0l491.397151-464.048559-237.654872-231.000535a38.82915 38.82915 0 0 0-54.112187 0 36.562288 36.562288 0 0 0 0 53.161566l171.111508 166.870283H410.960117a37.805406 37.805406 0 0 0 0 75.464562h481.15971L721.008319 715.889599a35.831042 35.831042 0 0 0-8.043703 40.949763 37.951655 37.951655 0 0 0 35.099796 23.18049 35.538544 35.538544 0 0 0 27.056094-10.968686l237.654872-231.293034a37.659157 37.659157 0 0 0 0-53.161567z m0 0" fill="#333333" p-id="3607" />
                        </svg>
                      </div>
                      <div>
                        <div class="left-text">退出系统</div>
                      </div>
                    </div>
                  </div>
                </transition>
              </div> -->
          </div>
          <ChatControl class="chatCSS"></ChatControl>
        </div>
      </el-main>
    </el-container>
  </div>
</template>
  
  <script>
import { mapState } from "vuex";
import heada_Image from "../assets/images/晨鸟log.png";
import { CountTo } from "vue3-count-to";
import Cookie from "js-cookie";
// import { ElNotification } from "element-plus";
import { ElLoading } from "element-plus";
import store from '../store/index'
import SendBox from "../views/Send/Send.vue";
import {L2Dwidget} from 'live2d-widget'
import ChatControl from "../views/UserControl/ChatControl.vue"
export default {
  components: {
    CountTo,
    SendBox,
    ChatControl
  },
  data() {
    return {
      xmgl:"icon iconfont icon-_xiangmuguanli",
      rightMuneShow: true,
      userData: {
        userName: "",
      },
      userForm: {},
      MainShow: false,
      ManpowerShow: false,
      CateringRecruitShow: false,
      LobbyShow: false,
      circleUrl: heada_Image,
      muunlist: [],
      money: localStorage.getItem("Money"),
      userId: null,
      duration: 2000,
      // 初始值
      startVal: 0,
      taskBarList: [],

      isSend: false,
      msgcount: 0,
      clasclick: 2,
      MarketReport: false,
      MarketsReport: false,
      chat: false,
      unreadmsg: 0,
      isbtn: false,
      headShow:false,
      experimentShow:false,
      scoreRank:0,
      groupCount: 0,

    };
  },
  computed: {
    ...mapState({
      Path: (state) => state.user.path,
      Round: (state) => state.user.round,
      Money: (state) => state.user.Money,
      TaskBar: (state) => state.user.taskBar,
      commit: (state) => state.user.commit,
      depcomit: (state) => state.user.depcomit,
      msgList: (state) => state.user.msg,
      Operationmsg: (state) => state.user.Operationmsg,
      Operationmsgcount: (state) => state.user.Operationmsgcount,
    }),
    tagsList () {
      return this.$store.state.tagsList.map((item) => item.name);
    },
    collapse () {
      return this.$store.state.collapse;
    },
  },
  watch: {
    Path: {
      handler(newName){
        if(newName == '/Main'){
          this.MainShow = true
          this.headShow = true
          this.experimentShow = false
          this.userData.userName = localStorage.getItem("ms_username");
          this.muunlist = this.noChildren();
          this.GetTaskBarList();
          this.$refs.child.scrollToBottom();
          this.Global.msgload();
          let that = this;
          this.GetGroupRanking()
          this.Getlive2d()
          if (that.$store.state.user.commit == 1) {
            that.isloading();
          }
        }else if(newName == '/selectiveexperiment'){
          this.experimentShow = true
          this.MainShow = false
          this.headShow = false
        }
      }
    },  
    money: {
      handler (newName) {
        this.money = newName;
      },
      immediate: true,
      deep: true,
    },
    TaskBar (val) {
      if (!isNaN(val)) {
        this.GetTaskBarList();
      }
    },
    commit (val) {
      if (val == 1) this.isloading();
    },
    depcomit (value) {
      if (value == 1) this.commitmd();
    },
    msgList: {
      handler (nval) {
        this.msgcount = parseInt(localStorage.getItem("msgcount"));
        if (this.msgcount == 0) {
          this.msgcount = nval.length;
          if (!this.isSend) {
            this.unreadmsg = this.msgcount;
          }
        }
        if (!this.isSend) {
          this.unreadmsg = nval.length - this.msgcount + this.unreadmsg;
        }
        this.msgcount = nval.length;
        localStorage.setItem("msgcount", this.msgcount);
      },
      deep: true, // 深度监听
      immediate: true, //立即执行
    },
    // Operationmsgcount: {
    //   handler (val) {
    //     if (val > 0) {
    //       ElNotification({
    //         title: "通知",
    //         message: this.Operationmsg,
    //         type: "info",
    //         customClass: "notifyStyle", //自定义类名
    //         offset: 200,
    //       });
    //     }
    //   },
    //   deep: true, // 深度监听
    //   immediate: true, //立即执行
    // },
  },
  mounted() {
    if(this.$route.path != '/selectiveexperiment' && this.$route.path != '/Previewtopic' && this.$route.path != '/ScoringRules'){
      this.$refs.child.scrollToBottom();
      this.Global.msgload();
      let that = this;
      if (that.$store.state.user.commit == 1) {
        that.isloading();
      }
    }
  },
  created() {
    if(this.$route.path != '/selectiveexperiment' && this.$route.path != '/Previewtopic'&& this.$route.path != '/ScoringRules'){
      this.Getlive2d()
      this.MainShow = true
      this.headShow = true
      this.experimentShow = false
      this.userData.userName = localStorage.getItem("ms_username");
      this.muunlist = this.noChildren();
      this.GetTaskBarList();
      this.GetGroupRanking()
    }else{
      this.experimentShow = true
    }
  },
  methods: {
    Getlive2d(){
      this.$nextTick(()=>{
        var clientWidth = this.$refs.MainRef.clientWidth
          L2Dwidget.init({
              model: {
                  jsonPath: 'https://unpkg.com/live2d-widget-model-koharu@1.0.5/assets/koharu.model.json',
              },
              display: {
              position: "right",
              width: clientWidth * 150 / 1920,
              height: clientWidth * 260 / 1920,
              hOffset: 0,
              vOffset: -20
              },
              mobile: {
                show: true,
                  scale: 0.5
              },
              react: {
                opacityDefault: 0.7,
                opacityOnHover: 0.2,
              }
            });
      })
    },
    noChildren () {
      var meumlist = JSON.parse(localStorage.getItem("Menu"));
      var muuns = [];
      var color = ['#233FE9','#FF6B3D','#B53BFE','#00D964','#FFC700']
      meumlist.forEach((item,index) => {
        muuns.push({
            icon: item.icon,
            path:item.path,
            index: item.name,
            title: item.lable,
            color: color[index],
            isZoomed: false
          });
      });
      return muuns;
    },
    async ExitSystem() {
      await this.$store.dispatch("user/logout", this.userData);
      this.$router.push(`/login`);
    },
    MeunClick(item){
      this.muunlist.forEach((value,index) => {
         if(value.index == item.index){
            this.muunlist[index].isZoomed = true
         }else{
          this.muunlist[index].isZoomed = false
         }
      });
      this.$router.push(item.path);
    },
    AchievementsClick(){
      this.$router.push("AchievementsCard");
    },
    MarketClick(){
      this.$router.push("MarketReportCard");
    },
    ScoringRulesClick(){
      this.$router.push("ScoringRules");
    },
    GetGroupRanking(){
      let expid= localStorage.getItem("expID");
      this.$http.get(`StudentData/GetGroupRanking?expID=${expid}`).then((res)=>{
        if (res.success) {
          this.scoreRank= res.dynamicObj.scoreRank
          this.groupCount = res.dynamicObj.groupCount
        } else {
          return this.$message.warning(res.message)
        }
      })
    
    },
    // 返回部门
    returnMainClick() {
      this.MainShow = true;
      this.ManpowerShow = false;
      this.LobbyShow = false;
      this.KitchenShow = false;
      this.ProcureShow = false;
      this.FinanceShow = false;
      this.MarketingShow = false;
    },
    dynamicStyles(item){
      return {
        'transform': item.isZoomed ? 'scale(1.05)' : 'scale(1)',
        'background-color': item.color,
      }
    },
    GetTaskBarList () {
      this.userId = localStorage.getItem("userId")
      this.$http
        .get(
          "TaskBars/GetTaskBarList?round=" +
          this.Round + '&userId=' + this.userId
        )
        .then((res) => {
          if (res.success) {
            this.taskBarList = res.dynamicObj
          } else {
            return this.$message.warning(res.message);
          }
        });
    },
     // 用户名下拉菜单选择事件
     handleCommand (command) {
      if (command == "loginout") {
        if(this.$route.path != '/selectiveexperiment' && this.$route.path != '/Previewtopic'&& this.$route.path != '/ScoringRules'){
          this.Global.beforeDestroy();
          localStorage.removeItem("accessToken");
          localStorage.removeItem("CurrentRound");
          localStorage.removeItem("caseId");
          localStorage.removeItem("groupID");
          localStorage.removeItem("Money");
          localStorage.removeItem("msg");
          localStorage.removeItem("SPmsg");
          localStorage.removeItem("floorlist");
          localStorage.removeItem("selectiveexperiment");
          localStorage.removeItem("userId");
          Cookie.remove("token");
          //Cookie.remove("depcomit");
          localStorage.removeItem("depcomit");
          localStorage.removeItem("operate");
          localStorage.removeItem("checkSummarize");
          Cookie.remove("commit");
          Cookie.remove("round");

          localStorage.removeItem("chatShows");
          localStorage.removeItem("chatValue");
          //this.$router.push("/");
        }
        localStorage.removeItem("ms_username");
        localStorage.removeItem("dis");
        localStorage.removeItem("access_tokenExp");
        localStorage.removeItem("create_time");
        localStorage.removeItem("un");
        this.$router.push("/login");
      }else if(command == 'myCollect'){
        this.$router.push("MyCollect");
      }
    },
    Jump (o) {
      var router = o.navigationBar.split('/');
      this.$router.push({
        path: router[1],
        query: {
          str: router[2]
        }
      });
    },
    getExhibition () {
      this.$http
        .get(
          "User/GetMoney?groupId=" +
          this.Global.groupid +
          "&round=" +
          this.Round
        )
        .then((res) => {
          if (res.success) {
            this.$store.commit("setMoney", res.dynamicObj);
          } else {
            return this.$message.warning(res.message);
          }
        });
    },
    // BtnMarketReport () {
    //   this.MarketReport = true;
    // },
    // BtnMarketsReport () {
    //   this.MarketsReport = true;
    // },
    sendclickclose () {
      this.isSend = false;
      if (!this.isSend) {
        this.clasclick = 2;
      }
    },
    sendclick (type) {
      if(window.location.href.includes("Main")){
        this.$message.error("请先选择部门");
              return;
      }
      // if(this.ManpowerShow == false&&
      // this.LobbyShow == false&&
      // this.KitchenShow == false&&
      // this.ProcureShow == false&&
      // this.FinanceShow == false&&
      // this.MarketingShow == false){
      //   this.$message.error("请先选择部门");
      //     return;
      // }
      this.clasclick = type;
      this.$refs.child.scrollToBottom();
      if (!(this.$refs.child.msgType != type && this.isSend)) {
        this.isSend = !this.isSend;
        this.$refs.child.msgType = "";
      }
      if (this.isSend) {
        this.$refs.child.msgType = type; //修改子组件data
        if (type == 0) this.unreadmsg = 0;
      }
      if (!this.isSend) {
        this.clasclick = 2;
      }
    },
    isloading () {
      let that = this;
      const loading = ElLoading.service({
        lock: true,
        text: "已提交正在运算，请等待(｀・ω・')",
        // background: "rgba(0, 0, 0, 0.7)",
      });
      const timer = setInterval(function () {
        that.$http  
          .get(`Run/IsComit?IsComit`)
          .then((childre) => {
            if (childre.success) {
              if (childre.dynamicObj.isRun) {
                clearInterval(timer);
                that.$store.commit("coomitmd", 0);
                that.$store.commit("changedepcomit", 0);
                let nextround = childre.dynamicObj.nextRound;
                that.$store.commit("changeround", nextround);
                store.commit("GetTaskBar", !store.state.user.taskBar); 
                that.getExhibition();
                loading.close();
              }
            } else {
              return that.$message.warning(childre.message);
            }
          });
      }, 5000);
    },
    commitmd () {
      let that = this;
      if (that.$store.state.user.depcomit == 1) {
        that.$store.commit("coomitmd", 1);
        // 如果是最后一个回合则不提交
      }
    },
  },
};
</script>
  <style>
.el-descriptions__body {
  color: #606266;
  background: transparent;
}
.el-main {
  padding: 0px;
}
.el-header {
  padding: 0px;
}
</style>
  <style lang="scss" scoped>
.common-layout {
  background-image: url(../images/main.jpg);
  background-size: cover; /* 图片等比例缩放并覆盖整个容器 */
  background-position: center; /* 图片居中显示 */
  background-repeat: no-repeat; /* 防止图片重复显示 */
  height: 100%;
}
.el-main {
  height: auto;
}
.main-herder {
  display: flex;
  justify-content: space-around;
  height: 100%;
  div {
    display: flex;
  }
}
div {
  display: flex;
}
.main-div {
  justify-content: space-around;
  align-items: center;
  height: 100%;
}
.main-center {
  // flex: 28;
  height: 95%;
  display: flex;
  justify-content: center;
  opacity: 0.90;
  width: 95%;
}
.mune-calss {
  flex-direction: column;
  // background-color: #d2d2d2;
  border-radius: 10px;
  cursor: pointer;
  width: 85%;
  margin: 10px;
  display: flex;
  align-items: center;
}
// .main-left :first-child {
//   background-color: #233FE9;
// }
// .main-left :nth-child(2) {
//   background-color: #FF6B3D;
// }
// .main-left :nth-child(3) {
//   background-color: #B53BFE;
// }
// .main-left :nth-child(4) {
//   background-color: #00D964;
// }
// .main-left :nth-child(5) {
//   background-color: #FFC700;
// }
.left-icon {
  justify-content: center;
  margin: calc(100vw * 10 / 1920);
}
.card-panel-icon {
  font-size: 48px;
}
.fund {
  background-color: white;
  border-radius: 5px;
  height: 60%;
  width: 17%;
  margin-right: 10px;
  align-content: center;
  align-items: center;
  justify-content: center;
  display: flex;
  opacity: 0.85;
  position: relative;
}
.fund2 {
  background-color: white;
  border-radius: 5px;
  height: 60%;
  width: 10%;
  margin-right: 10px;
  align-content: center;
  align-items: center;
  justify-content: center;
  display: flex;
  opacity: 0.85;
  position: relative;
}
.fund3 {
  background-color: white;
  border-radius: 5px;
  height: 60%;
  width: 15%;
  margin-right: 10px;
  align-content: center;
  align-items: center;
  justify-content: center;
  display: flex;
  opacity: 0.85;
  position: relative;
}
.fund1 {
  // background-color: #d2d2d2;
  // border-radius: 15px;
  height: 60%;
  width: 5%;
  margin-right: 0px;
  align-content: center;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.information {
  background-color: white;
  margin: 10px;
  border-radius: 15px;
  width: 28%;
  align-items: center;
  justify-content: center;
  flex-direction: row; /* 水平排列 */
  opacity: 0.85;
}
.information > div {
  flex: 1; /* 让子级 div 充满父级 flex 容器 */
  overflow: hidden; /* 防止内容溢出 */
}
.main-right {
  display: flex;
  flex-direction: row;
  flex-direction: column; 
}
.right-teles {
  width: 20px;
  height: 225px;
}
.right-div {
  background-color: #aab9cd;
  border-radius: 10px;
}
.main-left {
  display: flex;
  // flex: 2;
  flex-direction: column;
  align-items: center;
  background-color: #4BACC9;
  width: 7%;
  border-radius: 10px;
  justify-content: space-around;
  opacity: 0.85;
}
.title {
  height: 8%;
  width: 100%;
  background-color: red;
  display: flex;
  justify-content: center;
  align-items: center;
}
.left-text{
  color: #fff;
  font-size:calc(100vw * 20 / 1920); 
  padding: 5px;
}
.center-class {
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.navbar .menu li:nth-child(4) a {
  transition-delay: 0.18s;
  transform: rotate(825deg);
}
.iconsize {
  font-size: 45px;
}
#send {
  position: fixed;
  bottom: calc(100vw * 10 / 1920);
  right: calc(100vw * 10 / 1920);
  z-index: 99;
  width: 30%;
  border-radius: 15px 0px;
  text-align: right;
  height: 50%;
}
</style>
<style>
.notifyStyle .el-icon-info {
  color: #909399 !important;
}

/*谷哥滚动条样式*/

::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  position: absolute;
}
::-webkit-scrollbar-thumb {
  background-color: #acaba9;
}
::-webkit-scrollbar-track {
  background-color: rgb(255, 255, 255);
}
</style>
<style>
/* 取消input的上下箭头 */
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

input::-webkit-outer-spin-button {
  -webkit-appearance: none !important;
}

input[type="number"] {
  -moz-appearance: textfield;
}

.chatCSS{
  position: fixed;
  bottom: calc(100vw * 180 / 1920);
  right: calc(100vw * 110 / 1920);
  z-index: 99;
  width: 22%;
  height: 19%;
  opacity: 0.85;
}
</style>
  